/**
 * P7-01: 页面级懒加载 fallback 组件
 */
export function LoadingFallback({ pageName = '页面' }: { pageName?: string }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0d1026, #141a33)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#eef1ff',
      gap: '16px',
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '3px solid rgba(255,214,120,0.2)',
        borderTopColor: '#ffd678',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />
      <p style={{ fontSize: '14px', opacity: 0.6 }}>
        正在加载{pageName}...
      </p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  )
}
